module.exports = __webpack_public_path__ + "img/glocal-ai-icon-navbar-white.fcad2fcd.svg";